import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  let auth = localStorage.getItem("USER_ACCESS_TOKEN");
  if (auth) {
    return <Navigate to={"/home"} />;
  }
  return children;
};

export default PublicRoute;
